module.exports = __webpack_public_path__ + "static/media/ssl-blog.b6c3265b.png";